import React, { memo } from 'react';

// Components
import NoData from './NoData';
import CartProduct from 'components/Carts/CartProduct';

// Type
import { CartProductProps } from 'pages/Search/type';

// Interface
interface IList {
	type: string;
	currentValue?: string;
	isHiddeValue?: boolean;
	data?: CartProductProps[];
}

export const List: React.FC<IList> = (props) => {
	const {
		data,
		type,
		currentValue = '',
		isHiddeValue = false
	} = props;

	if (!data?.length && currentValue) {
		return <NoData
			data={data}
			type={type}
			isHiddeValue={isHiddeValue}
		/>;
	}

	const filteredDataByOnStock = data?.length
		? [...data]?.sort((a: any, b: any) => b.onStock - a.onStock)
		: [];

	return (
		<div className="search-screen__list">
			{!!filteredDataByOnStock?.length && filteredDataByOnStock.map((item: CartProductProps, i: number) => {
				const isFirst = i === 0;
				const uniqId = isFirst ? 'search-screen-list-id' : '';
				const uniqIdControl= isFirst ? 'search-screen-list-control' : '';
				const uniqIdAddProject= isFirst ? 'search-screen-list-add-project' : '';
				return <CartProduct
						{...item}
						type={type}
						key={crypto.randomUUID()}
						currentValue={currentValue}

						uniqId={uniqId}
						uniqIdControl={uniqIdControl}
						uniqIdAddProject={uniqIdAddProject}
					/>;
				}
			)}
		</div>
	);
};

export default memo(List);
